import axios, { AxiosError } from 'axios'
import Cookies from 'js-cookie'
import { AuthError, ForbiddenError, NetworkError, NotFoundError, ValidationError } from "./errorTypes";
import type { ApiError, ResponseError } from "./types";

declare module 'axios' {
  export interface AxiosRequestConfig {
    isAuthRequired?: boolean
    isRefreshRequest?: boolean
    metadataDescription?: {
      item: string;
      action: string;
    }
    // retryAfter?: number
  }
}

interface ApiClientConfig {
  baseUrl: string,
  getToken: () => Promise<string | null>;
  onUnauthorized: () => void;
}

let clientConfig: ApiClientConfig = {
  baseUrl: '',
  getToken: async () => null,
  onUnauthorized: () => {
    console.error('onUnauthorized handler is not configured. Call configureApiClient first.');
  },
};

export function configureApiClient(newConfig: ApiClientConfig) {
  if (!newConfig.baseUrl) {
    throw new Error('API baseUrl is not configured')
  }

  clientConfig = newConfig;
  instance.defaults.baseURL = newConfig.baseUrl
}

const instance = axios.create()

instance.defaults.timeout = 20000
instance.interceptors.request.use(
  async (config) => {
    const conf = {...config}
    if (typeof window === 'undefined') return conf;
    const CSRFToken = Cookies.get('csrf_token') || undefined;

    // По умолчанию авторизация требуется; отключается только явным isAuthRequired: false
    const isAuthRequired = config.isAuthRequired ?? true;
    conf.isAuthRequired = isAuthRequired;

    if (config.isRefreshRequest) {
      conf.headers['X-CSRF-Token'] = CSRFToken;
      return conf;
    }

    if (isAuthRequired) {
      const accessToken = await clientConfig.getToken() || '';

      if (!accessToken) {
        clientConfig.onUnauthorized();
        return Promise.reject(new Error('No access token available'));
      }

      conf.headers['Authorization'] = accessToken
    }

    return conf
  },
  (error) => {
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  (response) => {
    return response
  },
  (error: AxiosError<ResponseError>) => { // : AppError | ResponseError
    const {response, config, request, code} = error;

    if (axios.isAxiosError(error)) {
      if (response) { // status >=300 можно 3** отрезать в validation чёто-там в конфиге запроса
        // console.log(response);

        const status = response?.status;
        // const isSingleError = response?.data?.error?.code;

        const isRefreshRequest = config?.isRefreshRequest;
        const methodDescription = response.config?.metadataDescription;

        // if (isSingleError) {
        if (status === 401) {
          if (!config?.isAuthRequired) {
            clientConfig.onUnauthorized();
          } else {
            return Promise.reject(new AuthError())
          }
        }

        if (status === 403) {
          return Promise.reject(new ForbiddenError())
        }

        if (status === 404) {
          return Promise.reject(new NotFoundError())
        }

        if (status === 422) {
          return Promise.reject(new ValidationError('Validation failed', error.response?.data.error as unknown as Record<string, ApiError>))
        }

        if (isRefreshRequest) {
          return Promise.reject(new AuthError())
        }
        // } else if (typeof response?.data.error === 'object') {
        //   const validationMesages = response?.data.error as Record<string, ApiError>;

        //   throw new ValidationError(methodDescription + 'валидация не прошла', validationMesages)
        // }
      } else if (request) { //запрос сделан, но ответ не был получен
        // return new HttpError()
        return Promise.reject(new NetworkError("Нет ответа от сервера. TimeOut"));
      } else {
        return Promise.reject(new NetworkError("Не удалось выполнить запрос"));
      }
    }

    return Promise.reject(error)


    // if (response.status === 401) {
    //   if (!isLogoutRequest) {
    //     clientConfig.onUnauthorized();
    //   } else {
    //     Promise.reject({
    //       data: null,
    //       massage: 'Не авторизован',
    //       code: 'unauthorised'
    //     });
    //   }
    // }

    // if (response.status === 403) {
    //   Promise.reject({
    //     data: null,
    //     massage: 'Нет доступа',
    //     code: 'unauthorised'
    //   });
    // }

    // if (isRefreshRequest) {
    //   Promise.reject({
    //     data: null,
    //     massage: 'Не удалось зарефрешить',
    //     code: 'refresh error'
    //   });
    // }

    // if (response.status === 408 || response.status === 504) {
    //   Promise.reject({
    //     data: null,
    //     massage: 'Нет ответа от сервера',
    //     code: 'TIMEOUT_ERR'
    //   });
    // }

    // if (response.status === 429) {
    //   Promise.reject({
    //     data: null,
    //     massage: 'Too many requests',
    //     code: 'TOO_MANY_REQUESTS'
    //   });
    // }

  }
);

export default instance
